import { Grid } from "@mui/material";
import { FormikErrors } from "formik";
import React from "react";
import {
  ControlledCustomSelect,
  CustomFormLabel,
  CustomTextField,
} from "../../../../../../../components/formsComponents";
import {
  useCustomerFullInfo,
  useCustomerPropspect,
  useDispatchWrapper,
} from "../../../../../../../hooks";
import { useSelector } from "react-redux";
import { IStoreState } from "../../../../../../../redux/initialStoreState";

import {
  LoadState,
} from "../../../../../../../constants/enums";
import { InsurerCodeAutoSearch } from "../../../../../../../components/AutoCompleteSearches";


import {
  fetchLifeInsurancePolicyAdminAsync,
  fetchLifeInsurancePremiumAsync,
} from "../../../../../../../redux/lifeInsurancePolicy/lifeInsuranceBasicDetail/lifeInsuranceBasicDetailActions";
import { ComissionCodeSelect } from "../../../../../../../components/AutoCompleteSearches/ComissionCodeSelect";
import { UsersAutoSearchByRole } from "../../../../../../../components/AutoCompleteSearches/UsersAutoSearchByRole";
import { ISelectOption } from "../../../../../../../constants/types";
import { IPolicyCommission } from "../../../../../../../redux/policyCommission/policyCommission.types";
import { batch } from "react-redux";
import { LabelCard } from "../../../../../../../components/LabelCard/LabelCard";
import { PolicyFormSkeleton } from "../../../PoliciesCommon/PolicyFormSkeleton/PolicyFormSkeleton";
import { ILifeInsurancePolicyAdmin, ILifeInsurancePremium } from "../../../../../../../redux/lifeInsurancePolicy/lifeInsuranceBasicDetail/lifeInsuranceBasicDetail.types";

interface ILifeInsurancePolicyAdminProps {
  customerpolicyId?: number | null;
  policyAdmin: {
      values: ILifeInsurancePolicyAdmin;
      errors: any;
      handleChange: {
        (e: React.ChangeEvent<any>): void;
        <T_1 = string | React.ChangeEvent<any>>(
          field: T_1
        ): T_1 extends React.ChangeEvent<any>
          ? void
          : (e: string | React.ChangeEvent<any>) => void;
      };
      setFieldValue: (field: string, value: any) => void;
      setValues: (
        values: React.SetStateAction<ILifeInsurancePolicyAdmin>,
        shouldValidate?: boolean
      ) => Promise<void> | Promise<FormikErrors<ILifeInsurancePolicyAdmin>>;
    };
    policyPremimum: {
      values: ILifeInsurancePremium;
      errors: any;
      handleChange: {
        (e: React.ChangeEvent<any>): void;
        <T_1 = string | React.ChangeEvent<any>>(
          field: T_1
        ): T_1 extends React.ChangeEvent<any>
          ? void
          : (e: string | React.ChangeEvent<any>) => void;
      };
      setFieldValue: (field: string, value: any) => void;
      setValues: (
        values: React.SetStateAction<ILifeInsurancePremium>,
        shouldValidate?: boolean
      ) => Promise<void> | Promise<FormikErrors<ILifeInsurancePremium>>;
    };
}

export const LifeInsurancePolicyAdmin: React.FC<
  ILifeInsurancePolicyAdminProps
> = (props) => {
  const { customerpolicyId, policyAdmin, policyPremimum } = props;
  console.log("policyAdmin", policyAdmin)
  const { data, Loading } = useSelector(
    (storeState: IStoreState) =>
      storeState.lifeInsurance.basicDetails.policyAdmin
  );

  const { data: premiumData, Loading: premiumDataLoading } = useSelector(
    (storeState: IStoreState) => storeState.lifeInsurance.basicDetails.premium
  );
  const dispatch = useDispatchWrapper();
  const [saveLoading, setSaveLoading] = React.useState(false);
  const customerFullDetails = useCustomerFullInfo();
  const customerProspect = useCustomerPropspect();

  const handleInsurer = async (value: ISelectOption) => {
    policyAdmin.setValues({
      ...policyAdmin.values,
      insurer: value.value as string,
      comission_code: null,
      commission_percentage: null,
    });
  };

  const handleCommissionCode = (data: IPolicyCommission | null) => {
    if (data) {
      policyAdmin.setValues({
        ...policyAdmin.values,
        comission_code: data.policy_code,
        commission_percentage: data.commission_new,
      });
    } else {
      policyAdmin.setValues({
        ...policyAdmin.values,
        comission_code: null,
        commission_percentage: null,
      });
    }
  };

  React.useEffect(() => {
    if (customerpolicyId) {
      batch(() => {
        dispatch(fetchLifeInsurancePolicyAdminAsync(customerpolicyId));
        dispatch(fetchLifeInsurancePremiumAsync(customerpolicyId));
      });
    }
  }, []);
  const isInitialized = React.useRef(false);

  React.useEffect(() => {
    if (!customerpolicyId && customerFullDetails && !isInitialized.current) {
    policyAdmin.setValues((prevValues: any) => ({
      ...prevValues,
        branch_code: customerProspect.data.branch_code, 
        csr: customerProspect.data.csr,
        marketer: customerProspect.data.marketer,
      }));
      isInitialized.current = true;
    } else {
      policyAdmin.setValues({
        ...data,
        branch_code: customerProspect.data.branch_code,
      });
    }
  }, [data, customerProspect.data]);

  // React.useEffect(() => {
  //   if (customerProspect.data.branch_code) {
  //     dispatch(
  //       fetchBranchOfficeWithCallback(
  //         customerProspect.data.branch_code,
  //         (data) => {
  //           policyAdmin.setValues({
  //             ...policyAdmin.values,
  //             aga: data.name,
  //           });
  //         }
  //       )
  //     );
  //   }
  // }, [customerProspect]);

  React.useEffect(() => {
    policyPremimum.setValues(premiumData);
  }, [premiumData]);

  return (
    <>
    <LabelCard heading="Policy Admin" />
    {Loading === LoadState.InProgress ? (
        <>
          <PolicyFormSkeleton />
        </>
      ) : (
            <>
            <Grid container spacing={1}>
              <Grid item xs={12} lg={3}>
                <CustomFormLabel>Insurer</CustomFormLabel>
                <InsurerCodeAutoSearch
                  value={policyAdmin.values.insurer}
                  onSelect={handleInsurer}
                />
              </Grid>

          <Grid item xs={12} lg={3}>
            <CustomFormLabel>Comission Code</CustomFormLabel>
            <ComissionCodeSelect
              insurerCode={policyAdmin.values.insurer}
              value={policyAdmin.values.comission_code}
              onChange={handleCommissionCode}
            />
          </Grid>
          <Grid item xs={12} lg={3}>
            <CustomFormLabel>Commission %</CustomFormLabel>
            <CustomTextField
              fullWidth
              value={policyAdmin.values.commission_percentage}
              disabled
            />
          </Grid>

          <Grid item xs={12} lg={3}>
            <CustomFormLabel>AGA</CustomFormLabel>
            <CustomTextField
              name="aga"
              variant="outlined"
              size="small"
              type="text"
              fullWidth
              disabled
              value={policyAdmin.values.aga}
              onChange={policyAdmin.handleChange}
            />
          </Grid>

          <Grid item xs={12} lg={3}>
            <CustomFormLabel>AGA Code</CustomFormLabel>
            <CustomTextField
              name="branch_code"
              fullWidth
              value={policyAdmin.values.branch_code}
              disabled
            />
          </Grid>

          <Grid item xs={12} lg={3}>
            <UsersAutoSearchByRole
              label="Advisor 1"
              value={policyAdmin.values.advisor_one}
              onSelect={(data) => {
                policyAdmin.setValues({
                  ...policyAdmin.values,
                  advisor_one: data.user_fact_id as any,
                  advisor_one_code: data.user_code,
                });
              }}
              errorMessage={policyAdmin.errors.advisor_one}
            />
          </Grid>

          <Grid item xs={12} lg={3}>
            <UsersAutoSearchByRole
              label="Advisor 2"
              value={policyAdmin.values.advisor_two}
              onSelect={(data) => {
                policyAdmin.setValues({
                  ...policyAdmin.values,
                  advisor_two: data.user_fact_id as any,
                  advisor_two_code: data.user_code,
                });
              }}
            />
          </Grid>

          <Grid item xs={12} lg={3}>
            <UsersAutoSearchByRole
              label="Advisor 3"
              value={policyAdmin.values.advisor_three}
              onSelect={(data) => {
                policyAdmin.setValues({
                  ...policyAdmin.values,
                  advisor_three: data.user_fact_id as any,
                  advisor_three_code: data.user_code,
                });
              }}
            />
          </Grid>

          <Grid item xs={12} lg={3}>
            <UsersAutoSearchByRole
              value={policyAdmin.values.csr}
              label="CSR"
              onSelect={(value) => {
                policyAdmin.setValues({
                  ...policyAdmin.values,
                  csr: value.user_fact_id as any,
                  csr_code: value.user_code,
                });
              }}
            />
          </Grid>

          <Grid item xs={12} lg={3}>
            <CustomFormLabel>Status</CustomFormLabel>
            <ControlledCustomSelect
              name="status"
              variant="outlined"
              size="small"
              type="text"
              fullWidth
              displayEmpty
              placeholder="Select One"
              options={[
                { label: "Active", value: "ACTIVE" },
                { label: "Inactive", value: "INACTIVE" },
              ].map((data) => {
                return { label: data.label, value: data.value };
              })}
              value={policyAdmin.values.status}
              onChange={policyAdmin.handleChange}
            />
          </Grid>
        </Grid>
        </>
        )}
      <LabelCard heading="Premium" />
      {premiumDataLoading === LoadState.InProgress ? (
        <PolicyFormSkeleton />
      ) : (
        <Grid container spacing={1}>
          <Grid item xs={12} lg={3}>
            <CustomFormLabel>Policy Premium</CustomFormLabel>
            <CustomTextField
              name="policy_premium"
              variant="outlined"
              size="small"
              type="text"
              fullWidth
              value={policyPremimum.values.policy_premium}
              onChange={policyPremimum.handleChange}
            />
          </Grid>
          <Grid item xs={12} lg={3}>
            <CustomFormLabel>Payment Plan</CustomFormLabel>
            <CustomTextField
              name="payment_plan"
              variant="outlined"
              size="small"
              type="text"
              fullWidth
              value={policyPremimum.values.payment_plan}
              onChange={policyPremimum.handleChange}
            />
          </Grid>
          <Grid item xs={12} lg={3}>
            <CustomFormLabel>Commission Code (%)</CustomFormLabel>
            <CustomTextField
              name="commission_code_percentage"
              variant="outlined"
              size="small"
              type="text"
              fullWidth
              value={policyPremimum.values.commission_code_percentage}
              disabled
            />
          </Grid>
          <Grid item xs={12} lg={3}>
            <CustomFormLabel>Bonus %</CustomFormLabel>
            <CustomTextField
              name="bonus_percent"
              variant="outlined"
              size="small"
              type="text"
              fullWidth
              value={policyPremimum.values.bonus_percent}
              disabled
            />
          </Grid>
          <Grid item xs={12} lg={3}>
            <CustomFormLabel>Bonus Amount</CustomFormLabel>
            <CustomTextField
              name="bonus_amount"
              variant="outlined"
              size="small"
              type="text"
              fullWidth
              value={policyPremimum.values.bonus_amount}
              disabled
            />
          </Grid>
          <Grid item xs={12} lg={3}>
            <CustomFormLabel>FYC</CustomFormLabel>
            <CustomTextField
              name="fyc"
              variant="outlined"
              size="small"
              type="text"
              fullWidth
              value={policyPremimum.values.fyc}
              onChange={policyPremimum.handleChange}
            />
          </Grid>
          <Grid item xs={12} lg={3}>
            <CustomFormLabel>Status</CustomFormLabel>
            <ControlledCustomSelect
              name="status"
              variant="outlined"
              size="small"
              type="text"
              fullWidth
              displayEmpty
              placeholder="Select One"
              options={[
                { label: "Active", value: "ACTIVE" },
                { label: "Inactive", value: "INACTIVE" },
              ].map((data) => {
                return { label: data.label, value: data.value };
              })}
              value={policyPremimum.values.status}
              onChange={policyPremimum.handleChange}
            />
          </Grid>
        </Grid>
        
        )}
    </>
  );
};
